import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const AccessDeniedIllustration = (props: SVGProps) => {
  const { title = 'AccessDeniedIllustration', className, ...restProps } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      viewBox="0 0 230 200"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
      fill="none"
    >
      <title>{title}</title>
      <path
        d="M45.9523 45.0443C45.9521 41.1049 42.7583 37.9116 38.8188 37.9116H19.3451C15.4058 37.9118 12.2126 41.105 12.2124 45.0443C12.2124 48.9837 15.4057 52.1776 19.3451 52.1777H38.8188C42.7584 52.1777 45.9523 48.9838 45.9523 45.0443ZM47.4257 45.0443C47.4257 49.7978 43.5723 53.6519 38.8188 53.6519H19.3451C14.5917 53.6517 10.7383 49.7977 10.7383 45.0443C10.7384 40.2911 14.5918 36.4377 19.3451 36.4375H38.8188C43.5722 36.4375 47.4255 40.291 47.4257 45.0443Z"
        fill="white"
      />
      <path
        d="M27.0594 44.9672C27.0594 40.6641 23.5711 37.1758 19.268 37.1758C14.9649 37.1758 11.4766 40.6641 11.4766 44.9672V45.1244C11.4766 49.4275 14.9649 52.9159 19.268 52.9159C23.5711 52.9159 27.0594 49.4275 27.0594 45.1244V44.9672Z"
        fill="currentColor"
      />
      <path
        d="M26.3213 44.9657C26.3211 41.0697 23.1625 37.9116 19.2665 37.9116C15.3706 37.9118 12.2126 41.0698 12.2124 44.9657V45.1229C12.2124 49.0189 15.3705 52.1776 19.2665 52.1777C23.1626 52.1777 26.3213 49.019 26.3213 45.1229V44.9657ZM27.7954 45.1229C27.7954 49.833 23.9766 53.6519 19.2665 53.6519C14.5566 53.6517 10.7383 49.8329 10.7383 45.1229V44.9657C10.7384 40.2559 14.5567 36.4377 19.2665 36.4375C23.9765 36.4375 27.7953 40.2558 27.7954 44.9657V45.1229Z"
        fill="currentColor"
      />
      <path
        d="M88.9481 91.5352V153.528H0V91.5352H88.9481ZM1.47414 152.054H87.4747V93.0093H1.47414V152.054Z"
        fill="white"
      />
      <path
        d="M38.4055 81.3281H14.4023V105.331H38.4055V81.3281Z"
        fill="black"
        stroke="black"
        strokeWidth="1.94095"
        strokeMiterlimit="10"
      />
      <path
        d="M39.1451 80.5898V106.067H13.668V80.5898H39.1451ZM15.1421 104.593H37.6709V82.064H15.1421V104.593Z"
        fill="white"
      />
      <path
        d="M33.3764 87.3316L20.4762 100.232L19.4336 99.19L32.3345 86.2891L33.3764 87.3316Z"
        fill="white"
      />
      <path
        d="M33.3764 99.19L32.3345 100.232L19.4336 87.3316L20.4762 86.2891L33.3764 99.19Z"
        fill="white"
      />
      <path
        d="M180.669 39.8984V41.3726H62.6914V39.8984H180.669Z"
        fill="white"
      />
      <path
        d="M168.979 48.3125V63.1881H142.691V48.3125H168.979ZM144.166 61.714H167.506V49.7866H144.166V61.714Z"
        fill="white"
      />
      <path
        d="M130.19 47.6484H73.1055V72.6881H130.19V47.6484Z"
        fill="currentColor"
      />
      <path
        d="M124.581 52.5195V53.9937H77.7148V52.5195H124.581Z"
        fill="white"
      />
      <path d="M117.37 57.5312V59.0054H77.7148V57.5312H117.37Z" fill="white" />
      <path d="M88.1295 63.3398V64.814H77.7148V63.3398H88.1295Z" fill="white" />
      <path
        d="M173.085 35.5519C174.022 35.5519 174.78 34.7909 174.78 33.8521C174.78 32.9134 174.022 32.1523 173.085 32.1523C172.149 32.1523 171.391 32.9134 171.391 33.8521C171.391 34.7909 172.149 35.5519 173.085 35.5519Z"
        fill="white"
      />
      <path
        d="M167.207 35.5519C168.143 35.5519 168.901 34.7909 168.901 33.8521C168.901 32.9134 168.143 32.1523 167.207 32.1523C166.271 32.1523 165.512 32.9134 165.512 33.8521C165.512 34.7909 166.271 35.5519 167.207 35.5519Z"
        fill="white"
      />
      <path
        d="M161.328 35.5519C162.264 35.5519 163.023 34.7909 163.023 33.8521C163.023 32.9134 162.264 32.1523 161.328 32.1523C160.392 32.1523 159.633 32.9134 159.633 33.8521C159.633 34.7909 160.392 35.5519 161.328 35.5519Z"
        fill="white"
      />
      <path
        d="M180.995 26V102.608H62.3008V26H180.995ZM63.7749 101.134H179.522V27.4741H63.7749V101.134Z"
        fill="white"
      />
      <path
        d="M184.482 173.998C207.109 173.998 225.451 155.655 225.451 133.028C225.451 110.401 207.109 92.0586 184.482 92.0586C161.855 92.0586 143.512 110.401 143.512 133.028C143.512 155.655 161.855 173.998 184.482 173.998Z"
        fill="white"
      />
      <path
        d="M211.389 127.562H157.574C156.741 127.562 156.066 128.237 156.066 129.07V136.989C156.066 137.822 156.741 138.496 157.574 138.496H211.389C212.221 138.496 212.896 137.822 212.896 136.989V129.07C212.896 128.237 212.221 127.562 211.389 127.562Z"
        fill="#161718"
      />
      <path
        d="M212.053 129.073C212.053 128.705 211.755 128.407 211.387 128.407H157.573C157.205 128.407 156.907 128.705 156.907 129.073V136.992C156.908 137.359 157.205 137.657 157.573 137.657H211.387C211.755 137.657 212.053 137.359 212.053 136.992V129.073ZM213.737 136.992C213.737 138.289 212.685 139.341 211.387 139.341H157.573C156.275 139.341 155.223 138.289 155.223 136.992V129.073C155.223 127.775 156.275 126.723 157.573 126.723H211.387C212.685 126.723 213.737 127.775 213.737 129.073V136.992Z"
        fill="black"
        stroke="black"
        strokeWidth="2.21791"
        strokeLinejoin="round"
      />
    </svg>
  );
};
